import React from 'react'
import s from '../CreateQuiz.module.scss'
import { Divider } from '@material-ui/core';
import { ChoiceInput } from './ChoiceInput';

const QuestionInput = ({ updateChoiceImage, removeChoice, disableAddChoiceButton, setQuestionTitle, setChoiceTitles, addChoiceToQuestion, input, questionIndex }) => {
    const editTitle = (e) => {
        setQuestionTitle(e?.target?.value, questionIndex);
    }
    function addChoice() {
        addChoiceToQuestion(questionIndex)
    }

    return (
        <>
            <h4 className="mt-8 mb-5 font-weight-bolder">{input.titleToDisplay}</h4>
            <input defaultValue={input.questionToInput} key={input.titleToDisplay} onInput={editTitle} className="form-control form-control-solid" placeholder="Type question title..." />
            <div className={s.questionInputExample}>
                {input.exampleText}
            </div>
            <Divider className="my-3" />
            {input.choicesArray.map((inputChoice, index) =>
                <ChoiceInput
                    updateChoiceImage={updateChoiceImage}
                    removeChoice={removeChoice}
                    key={`${input.titleToDisplay}-${index}`}
                    setChoiceTitles={setChoiceTitles}
                    questionIndex={questionIndex}
                    choiceIndex={index}
                    choice={inputChoice}
                />
            )}
            <button
                onClick={addChoice}
                disabled={!input.questionToInput || disableAddChoiceButton}
                style={{ padding: '16px', marginTop: '11px', pointerEvents: !input.questionToInput ? 'none' : 'initial' }}
                className="full-width btn btn-outline-primary border-style-dashed">+ Add Choices
            </button>
        </ >
    )
}

export const QuestionInputStep = ({ updateChoiceImage, removeChoice, setQuestionTitle, setChoiceTitles, quiz, addChoiceToQuestion }) => {
    const questionInputs = [
        {
            titleToDisplay: 'Question 1',
            questionToInput: quiz.questions[0].title,
            choicesArray: quiz.questions[0].answers,
            exampleText: 'ex. What Style?',
        },
        {
            titleToDisplay: 'Question 2',
            questionToInput: quiz.questions[1].title,
            choicesArray: quiz.questions[1].answers,
            exampleText: 'ex. What Occasion?',
        },
    ]

    return (
        <>
            {questionInputs.map((input, questionIndex) =>
                <div key={input.titleToDisplay}>
                    <QuestionInput updateChoiceImage={updateChoiceImage} disableAddChoiceButton={input.choicesArray.length === 5} removeChoice={removeChoice} setChoiceTitles={setChoiceTitles} addChoiceToQuestion={addChoiceToQuestion} questionIndex={questionIndex} input={input} setQuestionTitle={setQuestionTitle} />
                </div>
            )}
            <Divider className="my-3" />
        </ >
    )
}
